import { ReachAPI } from '../../../ReachApi';
import {
    GlobalApiSuccessResponse,
    DataGetCellResponse,
    DataGetListResponse,
    LegacyGlobalReachApiInterface,
    GlobalReachApiResponse,
    SignageGetAllCalendarEventsResponse,
} from './Interface/ReachApi';

export const GlobalReachApi: LegacyGlobalReachApiInterface = {
    Security: ReachAPI.Security,

    runScriptWithFallback(
        url: string,
        params?: Record<string, string | number | boolean>,
        cacheId?: string
    ): Promise<GlobalReachApiResponse> {
        return ReachAPI.runScriptWithFallback(url, params, cacheId);
    },

    getWithFallback(
        url: string,
        dataType: string,
        params?: Record<string, string | number | boolean>,
        cacheId?: string
    ): Promise<GlobalApiSuccessResponse> {
        return ReachAPI.getWithFallback(url, dataType, params, cacheId);
    },

    data: {
        getCells(
            listId: string | number,
            cellRange: string,
            showMissingRows: boolean,
            security: ReachAPI.Security
        ): Promise<DataGetCellResponse> {
            return ReachAPI.data.getCells(listId, cellRange, showMissingRows, security);
        },

        getLists(
            listId: string | number,
            security: ReachAPI.Security
        ): Promise<DataGetListResponse> {
            return ReachAPI.data.getLists(listId, security);
        },
    },

    signage: {
        getAllCalendarEvents(calendarId: string): Promise<SignageGetAllCalendarEventsResponse> {
            return ReachAPI.signage.getAllCalendarEvents(calendarId);
        },
    },
};
